var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBody(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 445,
    height: 355,
    viewBox: "0 0 445 355",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M435.164 195.962C430.746 146.904 424.35 120.662 406.387 90.5041C371.541 56.0095 330.875 55.2695 296.694 36.7167C278.205 26.6543 266.05 23.6512 266.05 16.6142C266.05 13.4553 265.946 7.96068 266.495 1.50949H177.981C178.537 7.96068 178.433 13.4553 178.433 16.6142C178.433 23.6512 166.263 26.6543 147.774 36.7167C113.596 55.2833 67.5411 55.0095 38.081 89.5041C20.1112 119.669 13.526 140.904 9.30425 195.962C5.08252 251.019 15.5409 304.009 15.541 352.536H97.541C86.041 264.509 87.041 160.009 93.041 150.009C86.041 194.009 92.5411 309.009 98.4532 352.536H345.023C355.041 307.009 364.041 184.009 357.541 150.009C364.541 167.509 362.541 257.009 346.541 352.536H428.041C428.041 302.019 439.582 245.019 435.164 195.962Z",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBody);
export default __webpack_public_path__ + "static/media/body.c634c77c.svg";
export { ForwardRef as ReactComponent };